// window.addEventListener('DOMContentLoaded', (event) => {})

window.root = 'html'
document.addEventListener('DOMContentLoaded', function () {

    /* ==== base =============================== */
    require('./base/_resize')
    require('./base/_hasScroll')
    require('./base/_scrollSize')
    require('./base/_viewportHeight')
    require('./base/_textarea')
    require('./base/_editor')

    /* ==== extension ========================== */
    require('./extension/_toggle')
    require('./extension/_checkbox')
    require('./extension/_choose-group')
    require('./extension/_show-more')

    /* ==== module ============================= */
    require('./module/_modal')

    /* ==== common ============================= */
    require('./common/_aside-left')


    $(window).trigger('resize').trigger('scroll')
})
